import {
  AdminMetricsResponse,
  PerQuoteLineData,
} from '@snap-types/actions/calculate-metrics';

import type { API } from '../api';

export class AdminMetricsService {
  constructor(private api: API) {}

  getByDate = async (
    startDate: Date,
    endDate: Date,
  ): Promise<{
    metrics: AdminMetricsResponse[];
    perQuoteData: PerQuoteLineData[];
  }> => {
    const query = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };

    return this.api.get('/metrics', query);
  };
}
